import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { defaultURL, lokasiKamiMeta } from "../data/DataMetatags";
import { lokasiKamiBreadcrumb } from "../data/DataBreadcrumb";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import Head from "next/head";
import { GACustomEvent } from "src/utils/analytics";
const MapsLocator = dynamic(() => import("../components/MapsLocator"));

const temukanLokasiKami = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  useEffect(() => {
    GACustomEvent("locate_us_search", "view");
  }, []);

  return (
    <Layout>
      <Head>
        <script
          async
          id="markerclusterer"
          src="/vendor/markerclusterer/markerclusterer_compiled.js"
        />
      </Head>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={lokasiKamiBreadcrumb} />
      <HeadingComponent headingText="Temukan Lokasi Kami" margin="16px" />
      <LayoutCenter>
        <MapsLocator />
      </LayoutCenter>
    </Layout>
  );
};

temukanLokasiKami.getInitialProps = async ({ asPath }) => {
  const pageTitle = lokasiKamiMeta.title;
  const descriptionSEO = lokasiKamiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};
export default temukanLokasiKami;
